import React, { useEffect, useState } from "react";
import { mapTableRows } from "../../../../../../../../utils";
import {
  Button,
  Modal,
  PermissionTable,
  showToast,
  Skeleton,
  SmartTooltip,
  TableAdv,
} from "../../../../../../../../components";
import {
  getAllUsers,
  updateUser,
} from "../../../../../../../../redux/slices/setting/settingApi";
import { totalCountStart } from "../../../../../../../../redux/slices/totalCount/totalCountSlice";
import { usePagination } from "../../../../../../../../hooks";
import { useDispatch, useSelector } from "react-redux";
import { formatWords2 } from "../../../../../../../../utils/stringUtils";

const UserList = ({ selectedRole, onClose }) => {
  const [isViewModal, setIsViewModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [preselectedValues, setPreselectedValues] = useState([]);
  const [selectedValues, setSelectedValues] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const columns = [
    {
      key: "moduleName",
      label: "Module Name",
    },
    {
      key: "roleName",
      label: "Role Name",
    },
    {
      key: "userName",
      label: "User Name",
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => {
        return (
          <SmartTooltip description="View" noicon>
            <Button
              type="icon"
              icon={"visibility"}
              variant="text"
              color="black"
              size="sm"
              onClick={() => handleRowSelect(row)}
            />
          </SmartTooltip>
        );
      },
    },
  ];

  const handleRowSelect = (row) => {
    setSelectedUser(row);
    setIsViewModal(true);
    setPreselectedValues([
      ...row?.moduleAccess,
      ...row?.extraModuleAccess?.ats,
    ]);
  };

  const sampleData = [
    {
      name: "Dashboard",
      type: "path",
      path: "ats/dashboard",
      key: "dashboard",
      children: [],
    },
    {
      name: "My Profile",
      type: "path",
      path: "profile",
      key: "profile",
      children: [],
    },
    {
      name: "Leads",
      type: "path",
      key: "leads",
      path: "ats/leads",
      children: [
        {
          name: "Lead Profile",
          type: "tab",
          key: "leads_leadsprofile",
          path: "ats/leads#lead-profile",
          children: [],
        },
        {
          name: "My Leads",
          type: "tab",
          key: "leads_myleads",
          path: "ats/leads#my-leads",
          children: [],
        },
        {
          name: "My Team Summary",
          type: "tab",
          key: "leads_myteamsummary",
          path: "ats/leads#my-team-summary",
          children: [],
        },
        {
          name: "Daily Production",
          type: "tab",
          key: "leads_dailyproduction",
          path: "ats/leads#daily-production",
          children: [],
        },
        {
          name: "All Leads",
          type: "tab",
          key: "leads_allleads",
          path: "ats/leads#all-leads",
          children: [],
        },
        {
          name: "Leads Pending Approvals",
          type: "tab",
          key: "leads_pendingapprovals",
          path: "ats/leads#leads-pending-approvals",
          children: [],
        },
      ],
    },
    {
      name: "Campaigns",
      type: "path",
      key: "campaigns",
      path: "ats/campaigns",
      children: [
        {
          name: "Bulk Emails",
          type: "tab",
          key: "campaigns_bulkemails",
          path: "ats/campaigns#bulk-emails",
          children: [],
        },
        {
          name: "Email Templates",
          type: "tab",
          key: "campaigns_emailtemplates",
          path: "ats/campaigns#email-templates",
          children: [],
        },
        {
          name: "Assign",
          type: "tab",
          key: "campaigns_assign",
          path: "ats/campaigns#bulk-emails",
          children: [],
        },
        {
          name: "Followup Assign",
          type: "tab",
          key: "campaigns_followupassign",
          path: "ats/campaigns#followup-assign",
          children: [],
        },
      ],
    },
    {
      name: "Prospects",
      type: "path",
      key: "prospects",
      path: "ats/prospects",
      children: [
        {
          name: "Prospects",
          type: "tab",
          key: "prospects_propects",
          path: "ats/prospects#prospects",
          children: [],
        },
        {
          name: "My Team prospects",
          type: "tab",
          key: "prospects_myteamprospects",
          path: "ats/prospects#myteamprospects",
          children: [],
        },
      ],
    },
    {
      name: "Accounts",
      type: "path",
      key: "accountdetails",
      path: "ats/account-details",
      children: [
        {
          name: "Get Account Details",
          type: "tab",
          key: "accountdetails_getaccountdetails",
          path: "ats/account-details#get-account-details",
          children: [],
        },
        {
          name: "All Accounts",
          type: "tab",
          key: "accountdetails_allaccounts",
          path: "ats/account-details#all-accounts",
          children: [],
        },
      ],
    },
    {
      name: "Job Detials",
      type: "path",
      key: "jobsdetailsuiid",
      path: "ats/jobs/job-details",
      children: [
        {
          name: "Info",
          type: "tab",
          key: "jobsdetailsuiid_info",
          path: "ats/jobs/job-details?job-details=info",
          children: [],
        },
        {
          name: "Talent Match",
          type: "tab",
          key: "jobsdetailsuiid_talentmatch",
          path: "ats/jobs/job-details?job-details=talent-match",
          children: [],
        },
        {
          name: "Shortlisted",
          type: "tab",
          key: "jobsdetailsuiid_shortlisted",
          path: "ats/jobs/job-details?job-details=shortlisted",
          children: [],
        },
        {
          name: "Pipeline",
          type: "tab",
          key: "jobsdetailsuiid_pipeline",
          path: "ats/jobs/job-details?job-details=pipeline",
          children: [],
        },
        {
          name: "Submission",
          type: "tab",
          key: "jobsdetailsuiid_submission",
          path: "ats/jobs/job-details?job-details=submission",
          children: [],
        },
        {
          name: "Activities",
          type: "tab",
          key: "jobsdetailsuiid_activities",
          path: "ats/jobs/job-details?job-details=activities",
          children: [],
        },
        {
          name: "Job Campaign",
          type: "tab",
          key: "jobsdetailsuiid_jobcampaign",
          path: "ats/jobs/job-details?job-details=job-campaign",
          children: [],
        },
        {
          name: "Smart Insights",
          type: "tab",
          key: "jobsdetailsuiid_smartinsights",
          path: "ats/jobs/job-details?job-details=smart-insights",
          children: [],
        },
        {
          name: "Query String",
          type: "tab",
          key: "jobsdetailsuiid_querystring",
          path: "ats/jobs/job-details?job-details=query-string",
          children: [],
        },
        {
          name: "Resume Mining",
          type: "tab",
          key: "jobsdetailsuiid_resumemining",
          path: "ats/jobs/job-details?job-details=resume-mining",
          children: [],
        },
        {
          name: "Similar Submission",
          type: "tab",
          key: "jobsdetailsuiid_similarsubmission",
          path: "ats/jobs/job-details?job-details=similar-submission",
          children: [],
        },
        {
          name: "Qualifying Questions",
          type: "tab",
          key: "jobsdetailsuiid_qualifyingquestions",
          path: "ats/jobs/job-details?job-details=qualifying-questions",
          children: [],
        },
        {
          name: "Ai Calls",
          type: "tab",
          key: "jobsdetailsuiid_aicalls",
          path: "ats/jobs/job-details?job-details=ai-calls",
          children: [],
        },
      ],
    },
    {
      name: "Vendors",
      type: "path",
      key: "vendors",
      path: "ats/vendors",
      children: [],
    },
    {
      name: "Jobs",
      type: "path",
      key: "jobs",
      path: "ats/jobs",
      children: [
        {
          name: "All Jobs",
          type: "tab",
          key: "jobs_alljobs",
          path: "ats/jobs#all-jobs",
          children: [],
        },
        {
          name: "My Jobs",
          type: "tab",
          key: "jobs_myjobs",
          path: "ats/jobs#my-jobs",
          children: [],
        },
        {
          name: "My Jobs",
          type: "tab",
          key: "jobs_myjobs",
          path: "ats/jobs#my-jobs",
          children: [],
        },
        {
          name: "Draft Jobs",
          type: "tab",
          key: "jobs_draftjobs",
          path: "ats/jobs#draft-jobs",
          children: [],
        },
        {
          name: "Add New Job Post",
          type: "tab",
          path: "ats/jobs#add-new-job-post",
          key: "jobs_addnewjobpost",
          children: [],
        },
        {
          name: "My Jobs",
          type: "tab",
          path: "ats/jobs#my-jobs",
          key: "jobs_myjobs",
          children: [],
        },
        {
          name: "Job Boards",
          type: "tab",
          key: "jobs_jobboards",
          path: "ats/jobs#job-boards",
          children: [
            {
              name: "Internal DB",
              type: "tab",
              key: "jobs_jobboards_internaldb",
              children: [],
            },
            {
              name: "Career Builder",
              type: "tab",
              key: "jobs_jobboards_careerbuilder",
              children: [],
            },
            {
              name: "Monster",
              type: "tab",
              key: "jobs_jobboards_monster",
              children: [
                // {
                //   name: "Classic Search",
                // },
                // {
                //   name: "Power Search",
                // },
                // {
                //   name: "Monster Search",
                // },
              ],
            },
            {
              name: "Kult Search",
              type: "tab",
              key: "jobs_jobboards_kultsearch",
              children: [],
            },
            {
              name: "Integrated Search",
              type: "tab",
              key: "jobs_jobboards_integratedsearch",
              children: [
                {
                  name: "Internal DB",
                  type: "tab",
                  key: "jobs_jobboards_integratedsearch_Intenaldb",
                },
                {
                  name: "Career Builder",
                  type: "tab",
                  key: "jobs_jobboards_integratedsearch_careerbuilder",
                },
                {
                  name: "Monster",
                  type: "tab",
                  key: "jobs_jobboards_integratedsearch_monster",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Pipeline Candidates",
      type: "path",
      key: "pipelinecandidates",
      path: "ats/bdm/pipeline-candidates",
      children: [
        {
          name: "Pipeline Candidates",
          type: "tab",
          key: "pipelinecandidates_pipelinecandidates",
          path: "ats/bdm/pipeline-candidates",
          children: [],
        },
      ],
    },
    {
      name: "Client Submissions",
      type: "path",
      key: "clientsubmissions",
      path: "ats/bdm/client-submissions",
      children: [
        {
          name: "Client Submissions",
          type: "tab",
          key: "clientsubmissions_clientsubmissions",
          path: "ats/bdm/client-submissions",
          children: [],
        },
      ],
    },
    {
      name: "Follow up / interview",
      type: "path",
      key: "followupinterviews",
      path: "ats/bdm/followup-interviews",
      children: [
        {
          name: "Interview follow-up",
          type: "tab",
          key: "followupinterviews_interviewfollowup",
          path: "ats/bdm/followup-interviews",
          children: [],
        },
      ],
    },

    {
      name: "Confirmed / Starts (BDM)",
      type: "path",
      key: "confirmedstarts",
      path: "ats/bdm/confirmed-starts",
      children: [
        {
          name: "Confirmed / Starts",
          type: "tab",
          key: "confirmedstarts_confirmedstarts",
          path: "ats/bdm/confirmed-starts",
          children: [],
        },
      ],
    },
    {
      name: "Sourcing",
      type: "path",
      key: "applicants",
      path: "/ats/applicants",
      children: [
        {
          name: "All Applicants",
          type: "tab",
          key: "applicants_allapplicants",
          path: "ats/applicants#all-applicants",
          children: [],
        },
        {
          name: "Job Boards",
          type: "tab",
          key: "applicants_jobboards",
          path: "ats/applicants#job-boards",
          children: [
            {
              name: "Internal DB",
              type: "tab",
              key: "applicants_jobboards_internaldb",
              children: [],
            },
            {
              name: "Career Builder",
              type: "tab",
              key: "applicants_jobboards_careerbuilder",
              children: [],
            },
            {
              name: "Monster",
              type: "tab",
              key: "applicants_jobboards_monster",
              children: [
                // {
                //   name: "Classic Search",
                // },
                // {
                //   name: "Power Search",
                // },
                // {
                //   name: "Monster Search",
                // },
              ],
            },
            {
              name: "Kult Search",
              type: "tab",
              key: "applicants_jobboards_kultsearch",
              children: [],
            },
            {
              name: "Integrated Search",
              type: "tab",
              key: "applicants_jobboards_integratedsearch",
              children: [
                {
                  name: "Internal DB",
                  type: "tab",
                  key: "applicants_jobboards_integratedsearch_Intenaldb",
                },
                {
                  name: "Career Builder",
                  type: "tab",
                  key: "applicants_jobboards_integratedsearch_careerbuilder",
                },
                {
                  name: "Monster",
                  type: "tab",
                  key: "applicants_jobboards_integratedsearch_monster",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Campaigns (Recruitment)",
      type: "path",
      key: "recruitmentcampaigns",
      path: "ats/recruitment/campaigns",
      children: [],
    },
    {
      name: "Internal Submissions",
      type: "path",
      key: "recruitmentinternalsubmissions",
      path: "ats/recruitment/internal-submissions",
      children: [
        {
          name: "Internal Submissions",
          type: "tab",
          key: "recruitmentinternalsubmissions_internalsubmissions",
          path: "ats/recruitment/internal-submissions#internal-submissions",
          children: [],
        },
      ],
    },
    {
      name: "Interview follow-up",
      type: "path",
      key: "recruitmentinterviewfollowup",
      path: "ats/recruitment/interview-followup",
      children: [
        {
          name: "Interview Followup",
          type: "tab",
          key: "recruitmentinterviewfollowup_interviewfollowup",
          path: "ats/recruitment/Interview-followup#interview-followup",
          children: [],
        },
      ],
    },
    {
      name: "Jobs (Recruitment)",
      type: "path",
      key: "recruitmentjobs",
      path: "ats/recruitment/Jobs",
      children: [
        {
          name: "All Jobs",
          type: "tab",
          key: "recruitmentjobs_alljobs",
          path: "ats/recruitment/jobs#alljobs",
          children: [],
        },
        {
          name: "My Jobs",
          type: "tab",
          key: "recruitmentjobs_myjobs",
          path: "ats/recruitment/jobs#myjobs",
          children: [],
        },
      ],
    },
    {
      name: "Confirmed / Starts (Recruitment)",
      type: "path",
      key: "recruitmentconfirmedstart",
      path: "ats/recruitment/confirmed-start",
      children: [
        {
          name: "Confirmed/Starts",
          type: "tab",
          key: "recruitmentconfirmedstart_confirmedstarts",
          path: "ats/recruitment/confirmed-start#confirmedstarts",
          children: [],
        },
      ],
    },
    {
      name: "Hotlist",
      type: "path",
      key: "hotlist",
      path: "bs/benchsales",
      children: [
        {
          name: "Hotlist",
          type: "path",
          key: "benchsaleshotlist",
          path: "bs/benchsales/hotlist",
          children: [],
        },
      ],
    },
    {
      name: "Campaign (Bench Sales)",
      type: "path",
      key: "benchsalescampaign",
      path: "bs/benchsales/campaign",
      children: [],
    },
    {
      name: "Kult Fetch",
      type: "path",
      key: "benchsaleskultfetch",
      path: "bs/benchsales/kultfetch",
      children: [
        {
          name: "Kult Fetch",
          type: "path",
          key: "benchsaleskultfetch",
          path: "bs/benchsales/kultfetch",
          children: [],
        },
      ],
    },
    {
      name: "Reports",
      type: "path",
      key: "reports",
      path: "ats/reports",
      children: [
        {
          name: "ATS",
          type: "tab",
          key: "reports_ats",
          path: "ats/reports/ats",
          children: [
            {
              name: "RA Report",
              type: "tab",
              key: "reports_ats_rareport",
              path: "ats/reports/ats#rareport",
              children: [
                {
                  name: "RA Download Sheet",
                  type: "tab",
                  key: "reports_ats_rareport_radownloadsheet",
                  path: "ats/reports/ats/rareport#radownloadsheet",
                },
                // {
                //   name: "Recruitment Summary Report",
                //   type: "tab",
                //   key:"reports_ats_rareport_recruitmentsummaryreport",
                // }
              ],
            },
            {
              name: "BDM Report",
              type: "tab",
              key: "reports_ats_bdmreport",
              path: "ats/reports/ats#bdmreport",
              children: [
                {
                  name: "BDM Summary Report",
                  type: "tab",
                  key: "reports_ats_bdmreport_bdmsummaryreport",
                  path: "ats/reports/ats/bdmreport#bdmsummaryreport",
                },
                {
                  name: "BDM Download Sheets",
                  type: "tab",
                  key: "reports_ats_bdmreport_bdmdownloadsheets",
                  path: "ats/reports/ats/bdmreport#bdmdownloadsheets",
                },
              ],
            },
            {
              name: "Recruitment Report",
              type: "tab",
              key: "reports_ats_recruitmentreport",
              path: "ats/reports/ats#recruitmentreport",
              children: [
                {
                  name: "Recruiter Summary Sheet",
                  type: "tab",
                  key: "reports_ats_recruiterreport_recruitersummarysheet",
                  path: "ats/reports/ats/recruiterreports#recruitersummarysheet",
                },
                {
                  name: "Job Boards Credit Utilization Report",
                  type: "tab",
                  key: "reports_ats_recruiterreport_jobboardcreditutilizationreport",
                  path: "ats/reports/ats/recruiterreports#jobboardcreditutilizationreport",
                },
                {
                  name: "Kult AI Call Summary Report",
                  type: "tab",
                  key: "reports_ats_recruiterreport_kultaicallsummaryreport",
                  path: "ats/reports/ats/recruiterreports#kultaicallsummaryreport",
                },
              ],
            },
            {
              name: "Email Report",
              type: "tab",
              key: "reports_ats_emailreport",
              path: "ats/reports/ats#emailreport",
              children: [
                {
                  name: "Recruiter Email Delivary Report",
                  type: "tab",
                  key: "reports_ats_emailreport_recruiteremaildelivaryreport",
                  path: "ats/reports/ats/emailrreports#recruiteremaildelivaryreport",
                },
              ],
            },
          ],
        },
        {
          name: "Favourite Reports",
          type: "tab",
          key: "fav_reports_ats",
          path: "ats/reports/favouriteReports",
          children: [
            {
              name: "RA Report",
              type: "tab",
              key: "reports_ats_rareport",
              path: "ats/reports/ats#rareport",
              children: [
                {
                  name: "RA Download Sheet",
                  type: "tab",
                  key: "reports_ats_rareport_radownloadsheet",
                  path: "ats/reports/ats/rareport#radownloadsheet",
                  children: [],
                },
                // {
                //   name: "Recruitment Summary Report",
                //   type: "tab",
                //   key:"reports_ats_rareport_recruitmentsummaryreport",
                // }
              ],
            },
            {
              name: "BDM Report",
              type: "tab",
              key: "reports_ats_bdmreport",
              path: "ats/reports/ats#bdmreport",
              children: [
                {
                  name: "BDM Summary Report",
                  type: "tab",
                  key: "reports_ats_bdmreport_bdmsummaryreport",
                  path: "ats/reports/ats/bdmreport#bdmsummaryreport",
                  children: [],
                },
                {
                  name: "BDM Download Sheets",
                  type: "tab",
                  key: "reports_ats_bdmreport_bdmdownloadsheets",
                  path: "ats/reports/ats/bdmreport#bdmdownloadsheets",
                  children: [],
                },
              ],
            },
            {
              name: "Recruitment Report",
              type: "tab",
              key: "reports_ats_recruitmentreport",
              path: "ats/reports/ats#recruitmentreport",
              children: [
                {
                  name: "Recruiter Summary Sheet",
                  type: "tab",
                  key: "reports_ats_recruiterreport_recruitersummarysheet",
                  path: "ats/reports/ats/recruiterreports#recruitersummarysheet",
                },
                {
                  name: "Job Boards Credit Utilization Report",
                  type: "tab",
                  key: "reports_ats_recruiterreport_jobboardcreditutilizationreport",
                  path: "ats/reports/ats/recruiterreports#jobboardcreditutilizationreport",
                },
                {
                  name: "Kult AI Call Summary Report",
                  type: "tab",
                  key: "reports_ats_recruiterreport_kultaicallsummaryreport",
                  path: "ats/reports/ats/recruiterreports#kultaicallsummaryreport",
                },
              ],
            },
            {
              name: "Email Report",
              type: "tab",
              key: "reports_ats_emailreport",
              path: "ats/reports/ats#emailreport",
              children: [
                {
                  name: "Recruiter Email Delivary Report",
                  type: "tab",
                  key: "reports_ats_emailreport_recruiteremaildelivaryreport",
                  path: "ats/reports/ats/emailrreports#recruiteremaildelivaryreport",
                },
              ],
            },
          ],
        },
        {
          name: "WorkForce",
          type: "tab",
          key: "reports_workforce",
          path: "ats/reports#workforce",
          children: [],
        },
      ],
    },
    {
      name: "Marketplace",
      type: "path",
      key: "marketplace",
      path: "ats/marketplace",
      children: [
        {
          name: "Marketplace",
          type: "tab",
          key: "marketplace_marketplace",
          path: "ats/marketplace#marketplace",
          children: [],
        },
      ],
    },
    {
      name: "Marketplace Setup",
      type: "path",
      key: "marketplace_setup",
      path: "ats/marketplace/setup",
      children: [],
    },
    {
      name: "Settings",
      type: "path",
      key: "settings",
      path: "ats/settings",
      children: [
        {
          name: "Company Profile",
          type: "tab",
          key: "settings_companyprofile",
          path: "ats/settings#company-profile",
          children: [
            {
              name: "General Details",
              type: "tab",
              key: "settings_companyprofile_generaldetails",
              children: [],
            },
            {
              name: "Branding",
              type: "tab",
              key: "settings_companyprofile_branding",
              children: [],
            },
            {
              name: "Locale Information",
              type: "tab",
              key: "settings_companyprofile_localinformation",
              children: [],
            },
            {
              name: "Billing & Subscription",
              type: "tab",
              key: "settings_companyprofile_blllingsubscription",
              children: [],
            },
          ],
        },
        {
          name: "Configurations",
          type: "tab",
          key: "settings_configurations",
          path: "ats/settings#configurations",
          children: [
            {
              name: "Automation",
              type: "tab",
              key: "settings_configurations_automation",
              children: [],
            },
            {
              name: "Global Settings",
              type: "tab",
              key: "settings_configurations_globalsettings",
              children: [],
            },
            {
              name: "General Settings",
              type: "tab",
              key: "settings_configurations_generalsettings",
              children: [
                {
                  name: "RA Setting",
                  type: "tab",
                  key: "settings_configurations_generalsettings_rasettings",
                  children: [
                    {
                      name: "Company Settings",
                      type: "tab",
                      key: "settings_configurations_generalsettings_rasettings_companysetting",
                      children: [],
                    },
                    {
                      name: "Google Search Account Settings",
                      key: "settings_configurations_generalsettings_rasettings_googleSetting",
                      type: "tab",
                      children: [],
                    },
                  ],
                },
                {
                  name: "BDM Setting",
                  type: "tab",
                  key: "settings_configurations_generalsettings_bdmsettings",
                },
                {
                  name: "Recruitement",
                  type: "tab",
                  key: "settings_configurations_generalsettings_recruitement",
                },
                {
                  name: "Bench Sale Setting",
                  type: "tab",
                  key: "settings_configurations_generalsettings_benchsalesetting",
                },
              ],
            },
            {
              name: "Integration",
              type: "tab",
              key: "settings_configurations_integration",
              children: [],
            },
          ],
        },
        {
          name: "Access Control",
          type: "tab",
          key: "settings_accesscontrol",
          path: "ats/settings#access-control",
          children: [
            {
              name: "User Teams",
              type: "tab",
              key: "settings_accesscontrol_userteams",
              children: [],
            },
            {
              name: "Security",
              type: "tab",
              key: "settings_accesscontrol_security",
              children: [
                {
                  name: "Role",
                  type: "tab",
                  key: "settings_accesscontrol_security_role",
                },
                {
                  name: "Module Access",
                  type: "tab",
                  key: "settings_accesscontrol_security_moduleaccess",
                  children: [
                    {
                      name: "ATS",
                      type: "tab",
                      key: "settings_accesscontrol_security_moduleaccess_ats",
                    },
                    {
                      name: "WorkForce",
                      type: "tab",
                      key: "settings_accesscontrol_security_moduleaccess_workforce",
                    },
                  ],
                },
                {
                  name: "Report Access",
                  type: "tab",
                  key: "settings_accesscontrol_security_reportaccess",
                },
                {
                  name: "IP Whitelist",
                  type: "tab",
                  key: "settings_accesscontrol_security_iprestriction",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      name: "Add User",
      type: "path",
      key: "adduser",
      path: "ats/settings/add-user",
      children: [],
    },
     {
      name: "Resume Mining",
      type: "path",
      key: "jobsjobdetailsscheduleresumemining",
      path: "ats/jobs/job-details/schedule-resume-mining",
      children: [],
    },
    {
      name: "Help",
      type: "path",
      key: "help",
      path: "ats/help",
      children: [],
    },
    // {
    //   name: "Company-profile",
    //   type: "path",
    //   path: "ats/settings/company-profile",
    //   children: [
    //     {
    //       name: "View",
    //       type: "tab",
    //       children: [
    //         {
    //           name: "nested-View",
    //           type: "tab",
    //           children: [
    // {
    //   name: "Level 3",
    // },
    // {
    //   name: "child",
    // },
    //           ],
    //         },
    //         {
    //           name: "nested_child",
    //         },
    //       ],
    //     },
    //     {
    //       name: "Edit",
    //       type: "tab",
    //       children: [],
    //     },
    //   ],
    // }
  ];

  const fetchUsers = async () => {
    if (!selectedRole) {
      showToast("No role id selected!", "error");
      return;
    }
    setLoading(true);
    try {
      const res = await getAllUsers({
        coll: "User",
        ret: "firstName lastName uiid role extraModuleAccess",
        fil: {
          role: { type: "NONE", value: selectedRole.id },
          organizationId: {
            type: "NONE",
            value: user?.data.organizationId.uiid,
          },
        },
        ref: "Role",
        lim: limit,
        pg: page,
      });

      if (res?.data?.data) {
        setUsers(res.data.data);
      } else {
        setUsers([]);
      }
    } catch (err) {
      console.error("Error fetching users", err);
      showToast("Failed to fetch users", "error", 2000);
      setUsers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    const getModuleMap = (modules) => {
      const map = new Map();
      const traverse = (list) => {
        for (const item of list) {
          map.set(item.key, true);
          if (item.children?.length) traverse(item.children);
        }
      };
      traverse(modules);
      return map;
    };

    const existingMap = getModuleMap(selectedUser?.moduleAccess || []);

    const findNewModules = (modules) => {
      const result = [];

      for (const item of modules) {
        let newChildren = [];

        // Check if any nested children are new
        if (item.children?.length) {
          newChildren = findNewModules(item.children);
        }

        // Include this node if:
        // 1. The key itself is new, OR
        // 2. Any of its children are newly added
        if (!existingMap.has(item.key) || newChildren.length > 0) {
          result.push({
            ...item,
            children: newChildren,
          });
        }
      }

      return result;
    };

    const newModules = findNewModules(selectedValues);

    if (newModules && newModules.length > 0) {
      const res = await updateUser({
        id: selectedUser.doc_id,
        payload: {
          $set: { "extraModuleAccess.ats": newModules },
        },
      });

      if (res?.success) {
        showToast("User Updated Successfully", "success");
        setIsViewModal(false);
        onClose();
      } else if (!res?.success) {
        showToast(`${res?.msg}`, "error");
      }
    } else {
      showToast(`Please select any modules`, "error");
    }
  };

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {},
  );

  const { value } = useSelector((state) => state.totalCount);
  const totalCount = value?.someUser?.data || 0;

  useEffect(() => {
    dispatch(
      totalCountStart({
        collection: "users",
        coll: "User",
        tname: "someUser",
        app: "master",
        filters: {
          role: { type: "NONE", value: selectedRole.id },
          organizationId: {
            type: "NONE",
            value: user?.data.organizationId.uiid,
          },
        },
      }),
    );
    fetchUsers();
  }, [selectedRole, dispatch, page, limit]);

  // const rows = Array.from({ length: 10 }, (_, index) => ({
  //   moduleName: "ATS",
  //   roleName: "RA Manager",
  //   userName: "Javk Rayon",
  // }));
  const rows = users.map((u) => ({
    id: u.uiid,
    moduleName: selectedRole.moduleName,
    roleName: selectedRole.roleName || "N/A",
    userName: `${formatWords2(u.firstName || "")} ${formatWords2(u.lastName || "")}`,
    doc_id: u._id,
    moduleAccess: u.role?.moduleAccess?.ats,
    extraModuleAccess: u.extraModuleAccess,
  }));

  const mappedRows = mapTableRows(rows, columns);
  return (
    <div>
      {loading ? (
        <Skeleton variant="paragraph" lines={4} />
      ) : (
        <TableAdv
          rows={mappedRows}
          columns={columns}
          // serverPagination={true}
          totalCount={totalCount}
          page={page}
          limit={limit}
          serverOnSearch={(key, value) => {
            setSearchValue(value);
          }}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarRight={{
            search: true,
          }}
        />
      )}

      <Modal
        isOpen={isViewModal}
        onClose={() => {
          setIsViewModal(false);
          setSelectedValues([]);
        }}
        closeOnOutsideClick
        title="Add User Permission"
        width="max-w-2xl"
      >
        {/* <UserListInnerModal 
        onCancel={() => setIsViewModal(false)} 
        roleName={selectedRole.roleName}
        userId={selectedUserId}  
        docId={docId}
        /> */}
        <PermissionTable
          data={sampleData}
          preselectedModules={preselectedValues}
          disabledItems={selectedUser?.moduleAccess}
          onSelectionChange={(value) => setSelectedValues(value)}
        />

        <div className="flex justify-end mt-3">
          <Button title={"Save"} onClick={() => handleSave()} />
        </div>
      </Modal>
    </div>
  );
};

export default UserList;
